import { render } from "./TasksKanbanView.vue?vue&type=template&id=3e4833c8&scoped=true&ts=true&lang=pug"
import script from "./TasksKanbanView.vue?vue&type=script&lang=ts"
export * from "./TasksKanbanView.vue?vue&type=script&lang=ts"

import "./TasksKanbanView.vue?vue&type=style&index=0&id=3e4833c8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4833c8"]])

export default __exports__